import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { HazardSeverityDocument, hazardSeverityPullQueryBuilder } from './queryBuilder';

export function hazardSeveritiesFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<HazardSeverityDocument> {
  const syncConfig = configBuilder<HazardSeverityDocument>(RxdbCollectionNameV2.HAZARD_SEVERITIES);
  doNotAutoSync(syncConfig);

  pull(syncConfig, hazardSeverityPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.HAZARD_SEVERITIES, replicationState, [sites]);
}
